export const findFirstTextbox = (canvasInstance: fabric.Canvas | null) => {
  if (!canvasInstance) return null;

  const objects = canvasInstance.getObjects();
  return objects.find((obj) => obj.type === 'textbox');
};

export const selectFirstTextbox = (canvasInstance: fabric.Canvas | null) => {
  if (!canvasInstance) return false;

  const firstTextbox = findFirstTextbox(canvasInstance);

  if (firstTextbox) {
    canvasInstance.setActiveObject(firstTextbox);
    canvasInstance.renderAll();
    return true;
  }

  return false;
};

export const triggerSelectFirstTextbox = (canvasInstance: fabric.Canvas | null) => {
  if (!canvasInstance) return false;

  canvasInstance.fire('canvas:textbox:select:first');
  return true;
};
